import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=dea564c4&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=dea564c4&prod&lang=scss&scoped=true"
import style1 from "./Calendar.vue?vue&type=style&index=1&id=dea564c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea564c4",
  null
  
)

export default component.exports